import OfferingCardBuilder from 'components/OfferingCardBuilder';
import React from 'react';
import { LiveEvent } from 'types';

type LiveEventsCardProps = {
  className?: string;
  liveEventInfo?: LiveEvent;
};

const LiveEventsCard: React.FC<LiveEventsCardProps> = ({
  className,
  liveEventInfo,
}) => (
  <OfferingCardBuilder className={className} liveEventInfo={liveEventInfo}>
    <OfferingCardBuilder.Header />
    <OfferingCardBuilder.Body />
    <OfferingCardBuilder.Footer />
  </OfferingCardBuilder>
);

export default LiveEventsCard;
